import { computed, inject, ref } from 'vue'
import * as locales from 'date-fns/locale'

export function useLocale() {
    const locale = inject('locale', ref('en_US'))
    const intlNumberFormat = inject('intlNumberFormat', ref(null))

    return {
        locale,
        intlNumberFormat,
        dateFnsLocale: computed(() => {
            const localeCountry = locale.value?.replace('_', '') ?? 'enUS'
            const onlyLocale = locale.value?.split('_')[0] ?? null
            return locales[localeCountry] ?? locales[onlyLocale] ?? null
        })
    }
}